const config = {
    development: {
        apiEndpoint: 'http://127.0.0.1:8080/api',
        filesEndpoint: 'http://127.0.0.1:8080/files',
        apiTimeout: 20000,
        googleMapsApiKey: ''
    },
    //@ts-ignore
    production: window.prodConfig
    /*{
        apiEndpoint: 'http://127.0.0.1:8080/api',
        filesEndpoint: 'http://127.0.0.1:8080/files',
        apiTimeout: 20000,
        googleMapsApiKey: ''
    }*/
};

const activeConfig = process.env.NODE_ENV === 'development' ? config.development : config.production;

export default activeConfig;